import React from 'react';

const Loader = () => {
  let delay = 0;
  let key = 989;
  const text = 'BEVERIX';
  const textArr = text.split('');

  return (
    <div className='loading-component'>
      {/* <i className='fas fa-circle-notch'></i> */}
      <div className='loader'>
        {textArr.map((t) => (
          <h3 key={key++} className='load-heading' style={{ animationDelay: `${(delay += 0.15)}s` }}> {t}</h3>
        ))}
      </div>
    </div>
  );
};

export default Loader;
